import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-specialty-schedules',
  templateUrl: './specialty-schedules.component.html',
  styleUrls: ['./specialty-schedules.component.css']
})
export class SpecialtySchedulesComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public specialtyId: string
  ) { }

  ngOnInit(): void {
  }

}
